import { environment } from "src/environments/environment";




environment
class Endpoints {
    baseUrl: string = environment.baseUrl;
    AUTH_BASE = this.baseUrl + '/api/site';
    USER_BASE = this.baseUrl + '/api/users';
    ADMIN_BASE = this.baseUrl + '/api/admin';
    VEHICLE_BASE = this.baseUrl + '/api/vehicles';
    MISCELLANEOUS_BASE = this.baseUrl + '/api';
    UPLOADED_RESOURCES_BASE = this.baseUrl + '/uploads/';
    UPLOADED_THUMB_RESOURCES_BASE = this.UPLOADED_RESOURCES_BASE + 'thumb/';
    MARKETING_BASE = this.baseUrl + '/api/marketing';

    AUTH_ENDPOINTS = {
        LOGIN_IN: this.joinPaths(this.AUTH_BASE, 'login'),
        SIGN_UP: this.joinPaths(this.AUTH_BASE, 'signup'),
        SUBSCRIPTION_LIST: this.joinPaths(this.AUTH_BASE, 'get-subscription-packages'),
        FORGET_PASSWORD: this.joinPaths(this.baseUrl, 'site/forgotpassword'),
        VARIRY_OTP: this.joinPaths(this.baseUrl, 'site/verify/otp'),
        RESET_PASSWORD: this.joinPaths(this.baseUrl, 'site/resetpassword'),
        VERIFY_EMAIL: this.joinPaths(this.AUTH_BASE, 'verify-email'),
        CHANGE_PASSWORD: this.joinPaths(this.AUTH_BASE, 'change-password'),
        LOGOUT: this.joinPaths(this.AUTH_BASE, 'logout')
    };

    USER_ENDPONTS = {
        CHANGE_PASSWORD: this.joinPaths(this.USER_BASE, 'change-password'),
        LOGOUT: this.joinPaths(this.USER_BASE, 'logout'),
        MY_DETAILS: this.joinPaths(this.USER_BASE, 'my-details'),
        Business_Profile: this.joinPaths(this.USER_BASE, 'upload-company-logo'),
        Update_Business_Profile: this.joinPaths(this.USER_BASE, 'update-business-profile')
    };
    MISCELLANEOUS_ENDPOINTS = {
        GET_COUNTRY_LIST: this.joinPaths(this.MISCELLANEOUS_BASE, 'country'),
        GET_STATE_LIST: this.joinPaths(this.MISCELLANEOUS_BASE, 'state')
    };
    ADMIN_USER_ENDPOINTS = {
        GET_USER_LIST: this.joinPaths(this.AUTH_BASE, 'users/list?page='),
        GET_TRANSECTION_LIST: this.joinPaths(this.AUTH_BASE, 'transactions?page='),
        GET_TRANSFER_LIST: this.joinPaths(this.AUTH_BASE, 'all-transfers?page='),
        GET_REFUND_LIST: this.joinPaths(this.AUTH_BASE, 'all-refunds?page='),

        GET_PROMOCODE_LIST: this.joinPaths(this.AUTH_BASE, 'promocodes-all'),
        DELETE_PROMOCODE: this.joinPaths(this.AUTH_BASE, 'promocode-delete/'),
        ADD_PROMOCODE: this.joinPaths(this.AUTH_BASE, 'promocode-save'),
        UPDATE_PROMOCODE: this.joinPaths(this.AUTH_BASE, 'promocode-edit/'),

        GET_HELP_LIST: this.joinPaths(this.MARKETING_BASE, 'get-queries'),

        GET_OFFER_LIST: this.joinPaths(this.AUTH_BASE, 'offers-all'),
        DELETE_OFFER: this.joinPaths(this.AUTH_BASE, 'offer-delete/'),
        ADD_OFFER: this.joinPaths(this.AUTH_BASE, 'offer-save'),
        UPDATE_OFFER: this.joinPaths(this.AUTH_BASE, 'offer-edit/'),

        USER_STATUS_UPDATE_URL: (status, id) => this.joinPaths(this.ADMIN_BASE, 'change-user-status', status, id),
        GET_ALL_USER_LIST: this.joinPaths(this.ADMIN_BASE, 'get-all-users-list'),
        ADD_USER: this.joinPaths(this.AUTH_BASE, 'add-user'),
        USER_DETAIL: this.joinPaths(this.AUTH_BASE, 'user/'),
        UPDATE_USER: this.joinPaths(this.AUTH_BASE, 'edit-user/'),
        USER_LABOUR_WAGES_URL: this.joinPaths(this.ADMIN_BASE, 'save-labour-wages'),
        USER_USER_ACCOUNT_URL: this.joinPaths(this.ADMIN_BASE, 'add-user-account'),
        DELETE_USER: this.joinPaths(this.AUTH_BASE, 'delete-user/'),
        CHANGE_USER_PASSWORD: id => this.joinPaths(this.ADMIN_BASE, id, 'change-password'),
        GET_USER_ACCOUNT_LIST: this.joinPaths(this.ADMIN_BASE, 'get-user-account-list'),
        USER_INFO: this.joinPaths(this.baseUrl, 'site/my-details'),
        RATINGS: this.joinPaths(this.AUTH_BASE, 'ratings'),
        MY_DETAILS: this.joinPaths(this.AUTH_BASE, 'my-details'),
        UPLOAD_IMAGE: this.joinPaths(this.USER_BASE, 'upload'),
        ADD_CATEGORY:this.joinPaths(this.AUTH_BASE, 'category-save'),
        CATEGORIES_LIST : this.joinPaths(this.AUTH_BASE, 'categories?search='),
        DELETE_CATEGORY : this.joinPaths(this.AUTH_BASE, 'category-delete/'),
        EDIT_CATEGORY : this.joinPaths(this.AUTH_BASE, 'category-edit/'),
        DRIVER_DOCUMENTS_LIST: this.joinPaths(this.AUTH_BASE, '/drivers/documents?page=1'),
        UPDATE_DRIVER_DOCUMENTS: this.joinPaths(this.AUTH_BASE, 'driver/status'),
        GET_DRIVER_ACCOUNT: this.joinPaths(this.AUTH_BASE,'driver/bank/'),
        APPLY_JOBS: this.joinPaths(this.AUTH_BASE,'apply-job')
    };

    VEHICLE_ENDPOINTS = {
        ADD_VEHICLE_CATEGORY    : this.joinPaths(this.VEHICLE_BASE, 'add-category'),
        ADD_VEHICLE             : this.joinPaths(this.VEHICLE_BASE, 'add'),
        EDIT_VEHICLE_CATEGORY   : this.joinPaths(this.VEHICLE_BASE, 'edit-category/'),
        DELETE_VEHICLE_CATEGORY : this.joinPaths(this.VEHICLE_BASE, 'delete-category/'),
        SEARCH_CATEGORY         : this.joinPaths(this.VEHICLE_BASE, 'categories?search='),
        VEHICLE_DETAIL          : this.joinPaths(this.VEHICLE_BASE, 'view/'),
        VEHICLE_LIST            :  this.joinPaths(this.VEHICLE_BASE, 'all?category='),
        DELETE_VEHICLE          : this.joinPaths(this.VEHICLE_BASE, 'delete/'),
        ALL_CATEGORIES_LIST     : this.joinPaths(this.VEHICLE_BASE, 'all-categories'),
        UPDATE_VEHICLE          : this.joinPaths(this.VEHICLE_BASE, 'edit/')
    }

    MARKETING_ENDPOINTS = {
        GET_QUERIES    : this.joinPaths(this.MARKETING_BASE, 'get-queries?'),
        DELETE_QUERY    : this.joinPaths(this.MARKETING_BASE, 'delete-query/')
    }

    LEGAL_ENDPOINTS = {
        GET_LEGAL : this.joinPaths(this.AUTH_BASE, 'get-legal-list'),
        UPDATE_LEGAL : this.joinPaths(this.AUTH_BASE, 'edit-legal/'),
        ADD_LEGAL_QUESTION : this.joinPaths(this.AUTH_BASE, 'add-ques-ans'),
        UPDATE_LEGAL_QUESTION : this.joinPaths(this.AUTH_BASE, 'edit-qna/'),
        DELETE_QUESTION : this.joinPaths(this.AUTH_BASE, 'delete-qna/'),
    }
    QNAS_ENDPOINTS = {
        GET_QNAS : this.joinPaths(this.AUTH_BASE, 'get-qnas'),
        ADD_QNAS : this.joinPaths(this.AUTH_BASE, 'add-ques-ans'),
        UPDATE_QNAS : this.joinPaths(this.AUTH_BASE, 'edit-qna/'),
        DELETE_QNAS : this.joinPaths(this.AUTH_BASE, 'delete-qna/'),
    }
    TESTIMONIAL_ENDPOINTS = {
        GET_TESTIMONIAL : this.joinPaths(this.AUTH_BASE, 'get-testimonials'),
        ADD_TESTIMONIAL : this.joinPaths(this.AUTH_BASE, 'add-testimonial'),
        UPDATE_TESTIMONIAL : this.joinPaths(this.AUTH_BASE, 'edit-testimonial/'),
        DELETE_TESTIMONIAL : this.joinPaths(this.AUTH_BASE, 'delete-testimonial/'),
    }

    CMS_ENDPOINTS = {
        GET_PAGE : this.joinPaths(this.AUTH_BASE, 'get-page'),
        GET_PAGES : this.joinPaths(this.AUTH_BASE, 'get-pages'),
        EDIT_PAGE : this.joinPaths(this.AUTH_BASE, 'edit-page/'),
        GET_JOBS :  this.joinPaths(this.AUTH_BASE, 'get-all-jobs'),
        CREATE_JOB :  this.joinPaths(this.AUTH_BASE, 'add-job'),

        GET_JOB : (ID)=>  this.joinPaths(this.AUTH_BASE, 'get-job' ,ID),
        UPDATE_JOB : (ID)=>  this.joinPaths(this.AUTH_BASE, 'update-job' ,ID),
        DELETE_JOB : (ID)=>  this.joinPaths(this.AUTH_BASE, 'delete-job' ,ID),
        GET_ALL_APPLICATION : (ID)=>  this.joinPaths(this.AUTH_BASE, 'get-job' , ID),

        CREATE_BLOG : this.joinPaths(this.AUTH_BASE, 'add-blog'),
        GET_ALL_BLOG : this.joinPaths(this.AUTH_BASE, 'get-all-blogs'),
        ACTIVE_BLOG : this.joinPaths(this.AUTH_BASE, 'get-active-blogs'),
        POPULAR : this.joinPaths(this.AUTH_BASE, 'get-popular-blogs'),
        GET_ALL : this.joinPaths(this.AUTH_BASE, 'get-all-blogs'),
        UPDATE_BLOG : (ID)=>  this.joinPaths(this.AUTH_BASE, 'edit-blog' ,ID),
        DELETE_BLOG : (ID)=>  this.joinPaths(this.AUTH_BASE, 'delete-blog' ,ID),
        GET_BLOG : (ID)=>  this.joinPaths(this.AUTH_BASE, 'get-blog' ,ID),
        POPULAR_BLOG :   this.joinPaths(this.AUTH_BASE, 'get-popular-blogs'),

        REFUND_REQUEST :   this.joinPaths(this.AUTH_BASE, 'add-refund-request'),
       ALL_REFUND_REQUEST :   this.joinPaths(this.AUTH_BASE, 'get-all-tickets'),

    }


    private joinPaths(...params) {
        const newUrl = params.join('/');
        return newUrl;
    }
}
export const API = new Endpoints();
